import { DefaultRootState } from 'react-redux';

export const selectNegotiationsHistory = ({ negotiationsHistory }: DefaultRootState) => negotiationsHistory;
